<div class="loader">
  <div class="loader-container">
    <div class="spinner-border"></div>
  </div>
</div>
